module.exports = __webpack_public_path__ + "static/media/icon-progress-incorrect.4397df75.svg";